import Vue from 'vue'
import VeeValidate from 'vee-validate'

const config = {
  locale: 'zh',
  events: 'input',
  dictionary: {
    zh: {
      messages: {
        required: (field) => field + ' should not be empty.',
        min: (field, args) => field + ' should be at least ' + args + ' alphanumeric characters.',
        max: (field, args) => field + ' should be less than ' + args + ' alphanumeric characters.',
        digits: (field, args) => field + ' should be ' + args + ' digit',
        min_value: (field, args) => field + ' should be at least ' + args,
        max_value: (field, args) => field + ' should be less than ' + args,
        integer: (field) => field + ' should be integer',
        mimes: (field, args) => field + ' should be mime ' + args,
        ext: (field, args) => field + ' should be extension ' + args,
        dimensions: (field, args) => field + ' should be ' + args,
        regex: (field) => 'The ' + field + ' is incorrect.',
        email: () => 'Please enter right email format.',
        confirmed: () => 'Password confirmation is incorrect.'
      },
      attributes: {
      }
    }
  }
}

Vue.use(VeeValidate, config)



// WEBPACK FOOTER //
// ./src/plugins/validation.js